/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePalReauthReportGenerationRequest
 */
export interface UpdatePalReauthReportGenerationRequest {
    /**
     * 
     */
    overridden_report_text?: string | null;
}

/**
 * Check if a given object implements the UpdatePalReauthReportGenerationRequest interface.
 */
export function instanceOfUpdatePalReauthReportGenerationRequest(value: object): value is UpdatePalReauthReportGenerationRequest {
    return true;
}

export function UpdatePalReauthReportGenerationRequestFromJSON(json: any): UpdatePalReauthReportGenerationRequest {
    return UpdatePalReauthReportGenerationRequestFromJSONTyped(json, false);
}

export function UpdatePalReauthReportGenerationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthReportGenerationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'overridden_report_text': json['overridden_report_text'] === undefined ? undefined : json['overridden_report_text'] === null ? null : json['overridden_report_text'],
    };
}

export function UpdatePalReauthReportGenerationRequestToJSON(json: any): UpdatePalReauthReportGenerationRequest {
    return UpdatePalReauthReportGenerationRequestToJSONTyped(json, false);
}

export function UpdatePalReauthReportGenerationRequestToJSONTyped(value?: UpdatePalReauthReportGenerationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'overridden_report_text': value['overridden_report_text'],
    };
}

